import { Directive, ElementRef, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';

export type AspectRatioType = '16:9' | '1:1' | '9:16' | 'unknown';

@Directive({
    selector: '[appAspectRatio]',
})
export class AspectRatioDirective implements AfterViewInit, OnDestroy {
    @Output() aspectRatioChange = new EventEmitter<AspectRatioType>();

    private readonly TOLERANCE = 0.03;
    private mediaEl!: HTMLVideoElement;

    constructor(private el: ElementRef<HTMLVideoElement>) {}

    ngAfterViewInit(): void {
        this.mediaEl = this.el.nativeElement;

        if (this.mediaEl.readyState >= 1) {
            this.emitAspectRatio();
        } else {
            this.mediaEl.addEventListener('loadedmetadata', this.emitAspectRatio);
        }
    }

    ngOnDestroy(): void {
        this.mediaEl?.removeEventListener('loadedmetadata', this.emitAspectRatio);
    }

    private emitAspectRatio = (): void => {
        if (!this.mediaEl.videoWidth || !this.mediaEl.videoHeight) {
            this.aspectRatioChange.emit('unknown');
            return;
        }

        const ratio = this.mediaEl.videoWidth / this.mediaEl.videoHeight;

        if (Math.abs(ratio - 16 / 9) < this.TOLERANCE) {
            this.aspectRatioChange.emit('16:9');
            return;
        }

        if (Math.abs(ratio - 1) < this.TOLERANCE) {
            this.aspectRatioChange.emit('1:1');
            return;
        }

        if (Math.abs(ratio - 9 / 16) < this.TOLERANCE) {
            this.aspectRatioChange.emit('9:16');
            return;
        }

        this.aspectRatioChange.emit('unknown');
    };
}
